(function () {

  function initTabs(root) {
    if (!root) return;

    var tabButtons = root.querySelectorAll('[data-pusun-tab]');
    var panels = root.querySelectorAll('[data-pusun-panel]');
    // if (!tabButtons.length || !panels.length) return;

    function setActive(tabId) {
      tabButtons.forEach(function (btn) {
        var active = btn.getAttribute('data-pusun-tab') === tabId;
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
        btn.classList.toggle('is-active', active);
      });

      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-pusun-panel') === tabId;
        console.log("active",active);
        
        panel.classList.toggle('is-active', active);
      });
    }

    // 点击事件
    tabButtons.forEach(function (btn) {

      btn.addEventListener('click', function (e) {
        setActive(btn.getAttribute('data-pusun-tab'));
      });

      // 键盘支持 (Enter / Space)
      // btn.addEventListener('keydown', function (e) {
      //   if (e.key === 'Enter' || e.key === ' ') {
      //     e.preventDefault();
      //     btn.click();
      //   }
      // });
    });

    // 默认激活
    var defaultTab = root.getAttribute('data-default-tab') || tabButtons[0].getAttribute('data-pusun-tab');
    setActive(defaultTab);
  }

  function initAllTabs() {
    // document.querySelectorAll('[data-pusun-tabs-root]').forEach(initTabs);
    //  document.querySelector(body)
    initTabs(document.body)
  }

  // 页面加载时初始化
  document.addEventListener('DOMContentLoaded', initAllTabs);

  // Shopify Editor 动态加载 section 时初始化
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-pusun-tabs-root]');
    if (root) initTabs(root);
  });

  // Shopify Editor section 重新排序/刷新时也初始化
  document.addEventListener('shopify:section:select', function (event) {
    var root = event.target.querySelector('[data-pusun-tabs-root]');
    if (root) initTabs(root);
  });

})();